(function($) {
    'use strict';

    /**
     * Smooth hash scroll
     */
    $('a[href*="#"]').not('[href="#"]').click(function() {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top
                }, 400);
                return false;
            }
        }
    });

    /**
     * Dynamic vh
     */
    const appHeight = () => {
        const header = document.getElementById('header');
        const footer = document.getElementById('footer');
        const doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
        doc.style.setProperty('--footer-height', `${footer.offsetHeight}px`);
        doc.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }
    window.addEventListener('resize', appHeight);

    /**
     * Options Acordion 
     */
    $('.ctlg_form_field.accordion').addClass('accordion_open');
    var optionsWrapper = $('.radio_wrapper.accordion, .checkbox_wrapper.accordion');
    optionsWrapper.show();

    /*Filter: Search by name*/
    var searchContainer = $('#id_form_search_by_name').parent();
    var targetInput = $('#id_form_search_by_name');
    $(targetInput).focusin(function(){
        searchContainer.addClass('active');
    });
    $(targetInput).focusout(function(){
        if (targetInput.val() == '') {
            searchContainer.removeClass('active');
        }
    });
    $(document).ready(function() {
        if (targetInput.val()) {
            searchContainer.addClass('active');
        }
    });

    /**
     * Garden Telephone
     */
    $('.garden-telephone .element .button').click(function() {
        $(this).closest('.element').toggleClass('show');
    });
    $('.garden-telephone .element .close').click(function() {
        $(this).closest('.element').removeClass('show');
    });

    /* Tiles Masonry*/
    $(document).ready(function() {

        var grid = $('.mod_catalogUniversalView').imagesLoaded(function() {
            grid.masonry({
                itemSelector: '.ctlg_teaser',
                percentPosition: true
            });
        });
    });

})(jQuery);
